import { useParams } from 'react-router-dom';
import { entityConfigs, EntityType } from '@/entities/entityConfig';
import { MessageModal } from '@/shared/ui/Modal';

interface DeleteModalProps<TData = any> {
  selectedRows: TData[];
  isOpen: boolean;
  onOpenChange: () => void;
  entityName: EntityType;
}

export const DeleteMultipleModal = <TData extends { id: number }>({
  selectedRows,
  isOpen,
  onOpenChange,
  entityName,
}: DeleteModalProps<TData>) => {
  const params = useParams();
  const config = entityConfigs[entityName];
  const [deleteItems, { isLoading }] = config.deleteMutation();

  const handleDelete = async () => {
    try {
      if (entityName === 'lessons') {
        const ids = selectedRows.map((row) => row.id);
        const courseId = params?.id && !isNaN(Number(params?.id)) ? Number(params?.id) : null;
        if (courseId) {
          await deleteItems({ ids, courseId }).unwrap();
        }
      } else {
        const ids = selectedRows.map((row) => row.id);
        await deleteItems({ ids }).unwrap();
      }
      onOpenChange();
    } catch (error) {
      // TODO: Add error notification
    }
  };

  return (
    <MessageModal
      toggleVisibility={handleDelete}
      variant="red"
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={config.deleteTitle}
      text={config.deleteText}
      confirmText="Delete"
      isLoading={isLoading}
    />
  );
};
